var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaPremiumDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#DAF9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 18C28.0005 12.4771 23.5233 8 18.0005 8C12.4776 8 8.00049 12.4771 8.00049 18C8.00049 23.5228 12.4776 28 18.0005 28C23.5233 28 28.0005 23.5228 28.0005 18Z",
    stroke: "#003E3E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8638 13.7221L19.7437 15.4964C19.8637 15.7434 20.1837 15.9804 20.4536 16.0257L22.0485 16.2929C23.0684 16.4643 23.3083 17.2103 22.5734 17.9462L21.3335 19.1964C21.1236 19.4081 21.0086 19.8164 21.0736 20.1087L21.4285 21.6562C21.7085 22.8812 21.0636 23.355 19.9887 22.7148L18.4939 21.8226C18.2239 21.6613 17.7789 21.6613 17.504 21.8226L16.0091 22.7148C14.9393 23.355 14.2893 22.8761 14.5693 21.6562L14.9243 20.1087C14.9893 19.8164 14.8743 19.4081 14.6643 19.1964L13.4244 17.9462C12.6945 17.2103 12.9295 16.4643 13.9494 16.2929L15.5442 16.0257C15.8092 15.9804 16.1291 15.7434 16.2491 15.4964L17.129 13.7221C17.609 12.7593 18.3889 12.7593 18.8638 13.7221Z",
    stroke: "#003E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaPremiumDesktop);
export default __webpack_public_path__ + "static/media/triva_premium_desktop.5e974ae3ebf707efe2a2eeee6933c3a3.svg";
export { ForwardRef as ReactComponent };